import React, { useState } from "react";
import { useFetcher } from "../../components/api";
import {
  Button,
  Checkbox,
  List,
  ListItem,
  Popover,
  Typography,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

interface EmpresaItem {
  codigo: number;
  nome: string;
}

export interface EmpresaFilterProps {
  selected: number[];
  onChange: (selected: number[]) => void;
  empresas?: EmpresaItem[];
}

export const EmpresaFilter = ({
  selected,
  onChange,
  empresas: empresasProp,
}: EmpresaFilterProps) => {
  const { response } = useFetcher<{
    count: number;
    data: EmpresaItem[];
    error: string;
  }>(empresasProp ? "" : "empresas");
  const empresas = empresasProp ?? response?.data.data ?? [];

  const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);
  const [pending, setPending] = useState<number[]>(selected);

  if (empresas.length <= 1) return null;

  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
    setPending(selected);
    setAnchor(e.currentTarget);
  };

  const handleApply = () => {
    onChange(pending);
    setAnchor(null);
  };

  const toggleEmpresa = (codigo: number) => {
    setPending((prev) =>
      prev.includes(codigo)
        ? prev.filter((x) => x !== codigo)
        : [...prev, codigo],
    );
  };

  const label =
    selected.length === 0
      ? "Todas as empresas"
      : `Empresas: ${selected.join(", ")}`;

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        endIcon={<ArrowDropDownIcon />}
        onClick={handleOpen}
        style={{
          maxWidth: 260,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
          }}
        >
          {label}
        </span>
      </Button>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <List
          dense
          style={{ minWidth: 220, maxHeight: 320, overflowY: "auto" }}
        >
          {empresas.map((e) => (
            <ListItem
              key={e.codigo}
              button
              onClick={() => toggleEmpresa(e.codigo)}
            >
              <Checkbox
                checked={pending.includes(e.codigo)}
                size="small"
                style={{ padding: 4 }}
              />
              <Typography variant="body2">{e.nome}</Typography>
            </ListItem>
          ))}
        </List>
        <div style={{ padding: "8px 12px", display: "flex", gap: 8 }}>
          <Button
            variant="outlined"
            size="small"
            style={{ flex: 1 }}
            onClick={() => setPending([])}
          >
            Limpar
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ flex: 1 }}
            onClick={handleApply}
          >
            Aplicar
          </Button>
        </div>
      </Popover>
    </>
  );
};
